import { render, staticRenderFns } from "./PasswordInfos.vue?vue&type=template&id=2b817648&scoped=true"
import script from "./PasswordInfos.vue?vue&type=script&lang=js"
export * from "./PasswordInfos.vue?vue&type=script&lang=js"
import style0 from "./PasswordInfos.vue?vue&type=style&index=0&id=2b817648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b817648",
  null
  
)

export default component.exports